import React, { useState, useEffect } from 'react';
import { getRandomQuote } from '../../services/quotes';
import './LoadingScreen.css';

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = 'Loading' }) => {
  const [quote] = useState(getRandomQuote());
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setDotCount(p => (p + 1) % 4), 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-screen-container">
      <div className="loading-content">
        {/* Animated spinner */}
        <div className="loading-spinner">
          <div className="loading-spinner__ring" />
          <div className="loading-spinner__ring loading-spinner__ring--2" />
          <div className="loading-spinner__dot" />
        </div>

        <p className="loading-message">
          {message}<span className="loading-dots">{'.'.repeat(dotCount)}</span>
        </p>

        <div className="loading-quote">
          <p className="quote-text">"{quote.text}"</p>
          <p className="quote-author">— {quote.author}</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
